<template>
    <div class="supplier-home">
        <el-container>
            <el-header class="supplier-header">
                <img src="@/assets/logo.png" class="header-logo" />
                <span class="header-title">华府人家 · 供应商投标平台</span>
                <div class="header-right">
                    <span>{{ supplierName }}</span>
                    <el-button type="text" @click="handleLogout">退出</el-button>
                </div>
            </el-header>
            <el-container>
                <el-aside width="200px" class="supplier-aside">
                    <el-menu router :default-active="$route.path">
                        <el-menu-item index="/supplier-home/dashboard"><i class="el-icon-s-home"></i>工作台</el-menu-item>
                        <el-menu-item index="/supplier-home/bidding"><i class="el-icon-s-order"></i>招标公告</el-menu-item>
                        <el-menu-item index="/supplier-home/quotes"><i class="el-icon-s-finance"></i>我的报价</el-menu-item>
                        <el-menu-item index="/supplier-home/contracts"><i class="el-icon-document"></i>我的合同</el-menu-item>
                        <el-menu-item index="/supplier-home/reconciliation"><i class="el-icon-s-check"></i>在线对账</el-menu-item>
                        <el-menu-item index="/supplier-home/progress"><i class="el-icon-s-data"></i>进度上报</el-menu-item>
                        <el-menu-item index="/supplier-home/qa"><i class="el-icon-question"></i>线上答疑</el-menu-item>
                        <el-menu-item index="/supplier-home/records"><i class="el-icon-trophy"></i>历史中标·考评</el-menu-item>
                    <el-menu-item index="/supplier-home/drawings"><i class="el-icon-picture"></i>工程图纸</el-menu-item>
                    </el-menu>
                </el-aside>
                <el-main class="supplier-main">
                    <router-view />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    export default {
        name: 'SupplierHome',
        data() {
            return {
                supplierName: ''
            }
        },
        created() {
            const info = JSON.parse(localStorage.getItem('supplier_info') || '{}')
            this.supplierName = info.companyName || info.contactName || '供应商'
        },
        methods: {
            handleLogout() {
                localStorage.removeItem('supplier_token'); localStorage.removeItem('supplier_info')
                this.$router.push('/supplier-login')
            }
        }
    }
</script>

<style scoped>
    .supplier-home { height: 100vh; display: flex; flex-direction: column; overflow: hidden; }
    .supplier-home > .el-container { flex: 1 1 auto; min-height: 0; }
    .supplier-header {
        background: #004070; color: #fff; display: flex; align-items: center; gap: 12px;
        height: 56px; padding: 0 20px;
    }
    .header-logo { width: 32px; height: 32px; }
    .header-title { font-size: 16px; font-weight: 600; flex: 1; }
    .header-right { display: flex; align-items: center; gap: 12px; }
    .supplier-aside { background: #f5f7fa; border-right: 1px solid #e4e7ed; }
    .supplier-main { background: #f0f2f5; padding: 16px; display: flex; flex-direction: column; min-height: 0; overflow: hidden; }
</style>
